import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import { useState } from "react";
import apiFactory from "../../../api";
import { useAdminSettingContext } from "../../../context/AdminSettingContext";
import { GeneralModal } from "../GeneralModal";

const StoreAppModal = ({
  isModalOpen,
  cancelModal,
  title,
  languageMap,
  selectedApplication,
  setApplicationList,
  applicationList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedApp, selectedApp } = useAdminSettingContext();
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [typeList, setTypeList] = useState([
    { value: "MOBILE", label: "MOBILE" },
    { value: "DESKTOP", label: "DESKTOP" },
    { value: "WEB", label: "WEB" },
    { value: "SERVICE", label: "SERVICE" },
  ]);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setIsLoading(true);

    try {
      const request = {
        ...values,
        appId: selectedApplication?.appId,
      };

      let result = await apiFactory.appApi.store(request);

      if (selectedApplication?.appId) {
        const appIndex = applicationList?.findIndex(
          (app) => app?.appId === selectedApplication?.appId
        );

        applicationList.splice(appIndex, 1);
      }

      applicationList?.unshift(result?.data);
      setApplicationList(...[applicationList]);
      cancelModal();
    } catch (error) {
      console.error("Error fetching alarm list data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDelete = async () => {
    if (!selectedApplication?.appId) return;

    let result = await apiFactory.appApi.delete({
      appId: selectedApplication?.appId,
    });

    if (result?.status === 200) {
      const appIndex = applicationList?.findIndex(
        (app) => app?.appId === selectedApplication?.appId
      );

      applicationList.splice(appIndex, 1);
      setApplicationList(...[applicationList]);

      if (selectedApp?.appId === selectedApplication?.appId) {
        setSelectedApp(null);
      }

      cancelModal();
    }
  };

  return (
    <Modal
      open={isModalOpen}
      footer={false}
      closeIcon={false}
      onCancel={cancelModal}
      //   title={languageMap?.["modal.labelManagement.title"] ?? "Label management"}
      title={title}
      closable={true}
      maskClosable={false}
    >
      <div>
        <Form
          onFinish={onFinish}
          initialValues={selectedApplication}
          autoComplete="off"
          layout="vertical"
          form={form}
          // onKeyDown={preventSubmitOnEnter}
        >
          <Form.Item
            label={"Type"}
            name="type"
            rules={[
              {
                required: true,
                message:
                  languageMap?.["as.menu.organization.organizationId"] ??
                  "Please input type!",
              },
            ]}
          >
            <Select style={{ width: "100%" }} options={typeList} />
          </Form.Item>
          <Form.Item
            label={"Name"}
            name="name"
            rules={[
              {
                required: true,
                message:
                  languageMap?.["as.menu.organization.organizationName"] ??
                  "Please input name!",
              },
            ]}
            normalize={(value) => (value ? value.toUpperCase() : "")}
          >
            <Input type="text" className="w-[100%]" maxLength={50} />
          </Form.Item>
          <Form.Item label={"Valid version"} name="validVersion">
            <Input
              type="text"
              className="w-[100%]"
              maxLength={5}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>

          {isLoading ? (
            <div className="flex justify-center mt-[10px]">
              <Spin
                indicator={<LoadingOutlined className="loader-icon" spin />}
              />
            </div>
          ) : (
            <div className="flex gap-[10px] justify-center mt-[10px]">
              <Button
                type="primary"
                htmlType="submit"
                className="bg-[grey]"
                onClick={cancelModal}
              >
                {languageMap?.["as.menu.organization.btnCancel"] ?? "Cancel"}
              </Button>
              <Button type="primary" className="bg-[#4db74d]" htmlType="submit">
                {selectedApplication
                  ? languageMap?.["as.menu.app.btnUpdate"] ?? "Update"
                  : languageMap?.["as.menu.app.btnCreate"] ?? "Create"}
              </Button>
              {selectedApplication && (
                <Button
                  type="primary"
                  className="bg-[red]"
                  onClick={() => setIsDeleteModal(true)}
                >
                  {languageMap?.["as.menu.organization.btnCancel"] ?? "Delete"}
                </Button>
              )}
            </div>
          )}

          {isDeleteModal && (
            <GeneralModal
              open={isDeleteModal}
              onCancel={() => setIsDeleteModal(false)}
              onConfirm={onDelete}
            />
          )}
        </Form>
      </div>
    </Modal>
  );
};
export { StoreAppModal };
